import React, {useEffect, useState} from "react";
import {Col, Form, Row} from "react-bootstrap";
import TodoList from "../../component/List/TodoList";
import {InputWithLabel} from "../../component/Form/InputWithLabel";
import Page from "../../component/Page/Page";
import Notify from "../../services/Notify";
import LoadingV2 from "../../component/Loading/LoadingV2";
import Box from "../../component/Box/Box";
import FormButtons from "../../component/Form/FormButtons";
import {AlertConfigurationsGroupsService} from "../../services/AlertConfigurationsGroupsService";
import BreadcrumbItem from "../../component/BreadcrumbItem/BreadcrumbItem";

function AlertGroupFormPage({history, match}) {

  const [isLoading, setIsLoading] = useState(false)

  const [entity, setEntity] = useState({});

  const alertConfigurationsGroupsService = new AlertConfigurationsGroupsService()

  const save = async (event) => {
    try {
      event.preventDefault()
      setIsLoading(true)
      await alertConfigurationsGroupsService.saveV2(entity);
      entity.id ? Notify.success('Configuraçao de Grupo atualizada!') : Notify.success('Configuraçao de Grupo criada!');
      history.goBack();
    } catch (error) {
      entity.id ? Notify.error('Erro ao atualizar Grupo', error) : Notify.error('Erro ao criar Grupo', error)
    } finally {
      setIsLoading(false)
    }
  }
  const findOneById = async (id) => {
    try {
      setIsLoading(true);
      const newEntity = await alertConfigurationsGroupsService.getAlertGroupById(id);
      setEntity(newEntity);
    } catch (e) {
      Notify.error('Erro ao recuperar dados do alerta', e);
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    if (match.params.id) {
      findOneById(match.params.id)
    }
  }, [match.params && match.params.id])
  return (
    <Page title="Grupo de alerta"
          breadcrumbs={[<BreadcrumbItem title="Lista de grupos" to="/list/notifications-groups"/>]}>
      <LoadingV2 isLoading={isLoading}>
        <Box title="Crie seu Grupo">
          <Form onSubmit={save}>
            <Row>
              <Col md={6}>
                <InputWithLabel
                  required
                  label="Nome do Grupo:"
                  onChange={e => setEntity({...entity, friendlyName: e.target.value})}
                  defaultValue={entity.friendlyName || ''}
                  inputType="text"
                />
              </Col>
              <Col md={6}>
              </Col>
              <Col md={12}>
                <TodoList title="Lista de Email's"
                          data={entity.emails || []}
                          inputType="email"
                          getItems={emails => setEntity({...entity, emails})} valueKey="email"
                          showSwitch={true}
                />
              </Col>
              <Col md={12} className="mt-5">
                <FormButtons history={history}/>
              </Col>
            </Row>
          </Form>
        </Box>
      </LoadingV2>
    </Page>
  )
}

export default AlertGroupFormPage;


// WEBPACK FOOTER //
// ./src/pages/Groups/AlertGroupFormPage.js